import { render, staticRenderFns } from "./TipsPage.vue?vue&type=template&id=2e37646c&scoped=true"
import script from "./TipsPage.vue?vue&type=script&lang=js"
export * from "./TipsPage.vue?vue&type=script&lang=js"
import style0 from "./TipsPage.vue?vue&type=style&index=0&id=2e37646c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37646c",
  null
  
)

export default component.exports